
import AboutPage from './pages/AboutPage'
import './App.css'


function App() {
  return (
    <div className="App">
     <AboutPage /> 
    </div>
  );
}

export default App;
